














































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import * as Common from "@/tenant/common";
import * as Components from '@/tenant/components';

@Component
export default class Main extends Vue {
  @Prop() public path: string;
  @Prop() public defaultRoute: string;
  @Prop() public accordion: string;

  public systemitems: Common.Favorite[] = new Array(0);
  public myitems: Common.Favorite[] = new Array(0);
  public topicsItems: Common.Topics[] = new Array(0);
  public countProjectItem:number = null;
  public countSalesOrder:number = null;
  public countSalesDelivery:number = null;
  public countSalesCharge:number = null;
  public countAloneInvoice :number = null;
  public countCarryOverInvoice :number = null;
  public countPurchaseOrder :number = null;
  public countPurchaseDelivery : number = null;
  public countPurchaseInvoice : number = null;  
  public countPurchaseCharge : number = null;
  public countRelocation : number = null;
  public countTransfer : number = null;
  public countTaking : number = null;
  public countReceive: number = null;
  public countSend :number = null;

  public campaigns: Common.Campaign[] = [];
  public showDialog:boolean = false;
  public campaignSrc: string = '';
  public campaignId:string = '';
  public created() {
    this.isTenantFavorite = localStorage['isTenantFavorite'] == 'true';

    for(var i = 1;i<=12;i++){
      var item = new Common.Favorite();
      item.name = 'お気に入り' + i;
      this.myitems.push(item);
    }
    this.loadMyFavarite();
    this.loadSystemFavarite();
    this.loadTaskCount();    
    this.$api.formatter.ensureListLoaded('topicsGroup').then(()=>this.loadTopics());

    this.$api.loadCampaigns().then(res => this.campaigns = this.$api.campaigns.filter(obj =>obj.isCampaign));

    document.documentElement.style.setProperty('--home_container_width', this.$api.useStockFunction ? '1100px' : '900px');
  }

  public loadSystemFavarite() {
    //システム共通のお気に入りをロードする
    const query = new Common.FavoriteQuery(Common.favoriteFlags.System);
    return this.$api.execute(query).then((res) => {
      const temp = res as Common.LoadResult;
      this.systemitems = temp.result;
    });
  }

  public isTenantFavorite :boolean = false;
  public get gripDisabled(){
    return this.isTenantFavorite && this.$api.perms.hasMenuPermission(Common.Favorite.perm) == false;
  }
  @Watch("isTenantFavorite")
  public onIsTenantFavoriteChanged(){
    this.loadMyFavarite();
    localStorage['isTenantFavorite'] = this.isTenantFavorite;
  }
  public loadMyFavarite() {
    //自分のお気に入りをロードする※現状は"個人のお気に入り"ではない
    const query = new Common.FavoriteQuery(this.isTenantFavorite ? Common.favoriteFlags.Public: Common.favoriteFlags.Private);
    return this.$api.execute(query).then((res) => {
      const temp = res as Common.LoadResult;
      for(var i= 0;i < 10;i++){
        if (i < res.result.length) this.$set(this.myitems,i,temp.result[i]);
        else {
          var item = new Common.Favorite();
          item.name = 'お気に入り' + (i +1);
          this.$set(this.myitems,i, item);
        }
        // this.myitems = temp.result;
      }
        

    });
  }

  public loadTaskCount(){
    this.$api.execute(new Common.TaskCountQuery('AllTaskCountQuery',false)).then(res => {
      var hash =  res as { [key: string]: number};
      this.countProjectItem = hash.ProjectItem;
      this.countSalesOrder = hash.SalesOrder;
      this.countSalesDelivery = hash.SalesDelivery;
      this.countSalesCharge = hash.SalesCharge;
      this.countAloneInvoice = hash.AloneInvoice;
      this.countCarryOverInvoice = hash.CarryOverInvoice;
      this.countPurchaseOrder = hash.PurchaseOrder;
      this.countPurchaseDelivery = hash.PurchaseDelivery;
      this.countPurchaseInvoice = hash.PurchaseInvoice;
      this.countPurchaseCharge = hash.PurchaseCharge;
      this.countRelocation = hash.StockRelocation;
      this.countTransfer = hash.StockTransfer;
      this.countTaking = hash.StockTaking;
      this.countReceive = hash.ReceivePayment;
      this.countSend = hash.SendPayment;
    });
  }

  public loadTopics(){
    var query = new Common.TopicsQuery();
    query.sort = 'lastUpdatedOn';
    query.perPage = 3;
    this.$api.execute(query).then(res=>{
      this.topicsItems = (res as Common.LoadResult).result;
    });
  }
  public getPath(index: number) {
    const item = this.systemitems[index];
    return item.path + "?favorite=" + item.key;
  }
  public getPath2(index: number) {
    const item = this.myitems[index];
    return item.path + "?favorite=" + item.key;
  }
  
  public onShowBarcode(){
    // 権限確認
    if (this.$api.perms.validateURL('/journal/Barcode') == false) return false; 
    
    (this.$refs.barcode as Components.BarcodeDialog).show();
  }

  public onFormClick(item:Common.Campaign){
    // var iframe = (document.getElementById('iframe') as HTMLIFrameElement);
    // if (iframe){
    //   var temp = iframe.src;
    //   iframe.src = '';
    //   iframe.src = temp;
    // }
    this.campaignSrc = 'https://forms.zohopublic.com/code-x/form/' + item.formGUID + '?userId=' + this.$api.auth.userId + '&userName=' + this.$api.auth.userName + '&campaignId=' + item.id + '&tenantId=' + this.$api.license.tenantId + '&tenantName=' + this.$api.license.tenantName + '&totalCount=' + item.totalCount + '&userCount=' + item.userCount;
    this.campaignId = item.id.toString();

    // 別タブ表示に変更
    // this.showDialog = true;
    window.open(this.campaignSrc, '_blank');

    // //テストソース
    // var entry = new Webhook();
    // entry.campaignId = item.id;
    // entry.tenantid = this.$api.license.tenantId;
    // entry.userId = this.$api.auth.userId;
    // entry.userName = this.$api.auth.userName;
    // this.$api.execute(entry);

  }
  public async onCampaignClose(){
    return this.$api.loadCampaigns().then(res => this.campaigns = this.$api.campaigns.filter(obj =>obj.isCampaign));
  }
  public onFormSubmit(event:any){
    if (event.data == 'form_posted'){
      var webhook = new Common.Webhook();
      webhook.tenantid = this.$api.license.tenantId;
      webhook.userId = this.$api.auth.userId;
      webhook.userName = this.$api.auth.userName;
      webhook.campaignId= this.campaignId;
      this.$api.execute(webhook).then(res => this.onCampaignClose());
    } else if (event.data == 'form_closed'){
      this.showDialog = false;
    }
  }
  @Watch('showDialog')
  public onFormClosed(){
    if (this.showDialog){
      //イベントリスナの挿入
      window.addEventListener('message',this.onFormSubmit);    
    } else {
      //イベントリスナの削除
      window.removeEventListener('message',this.onFormSubmit);    
    }
  }

  private sourceId:number;
  private targetId:number = -1;
  public dragStart(index: number, e: any) {
    e.dataTransfer.effectAllowed = "move";
    this.sourceId = index;
    this.targetId = -1;
    console.log(String.format('dragsart index:={0}',index));      
  }
  public dragOver(index: number, e: any) {
    if (e.preventDefault) e.preventDefault(); // Necessary. Allows us to drop.
    e.dataTransfer.dropEffect = 'move'; // See the section on the DataTransfer object.

    console.log(String.format('dragover index:={0}',index));  

    //スタートセルとの相対関係でドロップ境界を判定する
    if (index == this.sourceId) this.targetId = -1;
    else this.targetId = index;
    return false;
  }
  public drop(index: number, e: any) {     
    console.log(String.format('dragdrop index:={0}',index));    
    const source = this.myitems[this.sourceId];
    const target = this.myitems[index];
    this.targetId = -1;

    if(this.sourceId != index)  {
      this.$api.execute(new Common.DisplayOrderOnHomeUpdateQuery(source,target.displayOrderOnHome)).then(()=>{
        this.loadMyFavarite();
      });
    }
  }    

  public dragleave(index:number){
    console.log(String.format('dragleave index:={0}',index));    
    this.targetId = -1;
  }  
  public onClick(path:string){
    this.$router.push(path);
  }

  dialogBarcodeQR:boolean = false;
  barcodeUrl:string = '';
  public showBarcodeQR() {    
    this.barcodeUrl = location.origin + '/barcode';

    var isIos = /iPhone|iPad|iPod/.test(navigator.userAgent);
    var isAndroid = /android/i.test(navigator.userAgent);
    //携帯端末の場合はアプリURLに遷移(リロード)・PC版の場合はQRコードを表示
　 if (isIos || isAndroid) location.href = this.barcodeUrl;
    else this.dialogBarcodeQR = true;
  }

}
